import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../context/ThemeContext';

const MODES = ['all', 'shipments', 'weather'];

const LayerToggle = ({ layerMode, onModeChange, variant = 'floating' }) => {
  const { t } = useTranslation();
  const { isDark } = useTheme();

  const labels = {
    all: t('map.layers.all', 'All'),
    shipments: t('map.layers.shipments', 'Shipments'),
    weather: t('map.layers.weather', 'Weather'),
  };

  return (
    <div
      role="radiogroup"
      aria-label={t('map.layers.all', 'Map layers')}
      className={`${
        variant === 'inline'
          ? 'flex w-full'
          : 'absolute top-3 right-3 z-[1000] flex shadow-md backdrop-blur-sm'
      } rounded-lg overflow-hidden border ${
        isDark ? 'border-[#333] bg-[#1d1d1d]/90' : 'border-[#e5e7eb] bg-white/90'
      }`}
    >
      {MODES.map((mode) => (
        <button
          key={mode}
          role="radio"
          aria-checked={layerMode === mode}
          onClick={() => onModeChange(mode)}
          className={`px-3 py-1.5 text-xs font-medium transition-colors ${variant === 'inline' ? 'flex-1' : ''} ${
            layerMode === mode
              ? 'bg-bloom-green text-white'
              : isDark
                ? 'text-gray-300 hover:bg-[#282a29]'
                : 'text-[#4b5563] hover:bg-[#f3f4f6]'
          }`}
        >
          {labels[mode]}
        </button>
      ))}
    </div>
  );
};

export default LayerToggle;
